import { formatNumberOnly } from './validators'

export const e164 = (phoneNumber: string) => {
  const justNumbers = formatNumberOnly(phoneNumber)
  const justNumbersLength = justNumbers.length
  if (justNumbersLength < 10) {
    return false
  }
  return justNumbersLength === 10 ? `+1${justNumbers}` : `+${justNumbers}`
}
